// extracted by mini-css-extract-plugin
export default {"inputCont":"OpenEndedPageModule_inputCont__Apm4z","gap":"OpenEndedPageModule_gap__72ZXj"};